export default {
      id: "security-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#security",
      toString: function () {
        return this.url;
      }
    }